import styled, { keyframes, createGlobalStyle } from 'styled-components'

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

export const VideoPlayerGlobalStyles = createGlobalStyle`
    [data-media-player] {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        border-radius: 0.5rem;
        overflow: visible;
        background-color: #000;
    }

    [data-media-player] video {
        width: 100%;
        height: auto;
        display: block;
    }

    [data-media-provider] {
        display: block;
        width: 100%;
        height: 100%;
    }
`

export const VideoLoaderContainer = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    background-color: #000;
    aspect-ratio: 16 / 9;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const VideoLoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    z-index: 10;
    border-radius: 0.5rem;
`

export const Spinner = styled.div`
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-top: 3px solid #fff;
    border-radius: 50%;
    width: 3.125rem;
    height: 3.125rem;
    animation: ${spin} 1s linear infinite;
`
